var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChannels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.564 2.577a8.815 8.815 0 00-9.135 8.86 8.687 8.687 0 002.868 6.56.74.74 0 01.247.51v1.627a.74.74 0 001.032.648l1.827-.795a.685.685 0 01.484 0c.864.234 1.755.35 2.65.348a8.879 8.879 0 00.027-17.758zm5.48 6.814l-2.676 4.257a1.369 1.369 0 01-1.982.366l-2.138-1.599a.548.548 0 00-.657 0l-2.887 2.192a.43.43 0 01-.621-.575l2.676-4.257a1.37 1.37 0 011.982-.365l2.138 1.598a.548.548 0 00.658 0l2.886-2.192a.43.43 0 01.621.575z",
    fill: "#2F54EB"
  })));
}

export default __webpack_public_path__ + "./fonts/channels.21cdd005f62962fe84462ec3ff08ca6d.svg";
export { SvgChannels as ReactComponent };